module.exports = __webpack_public_path__ + "img/HHbemleklap2023.96786602.jpg";